let eventName = null;

class FreeTrialEvent{
    construct()
    {
    }
    async push(step, options)
    {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: 'free_trial',
            step: step,
            options: options,
            user:  //we want user data in a dedicated object for consistency and overall tidiness
                step === 1 ? {
                    customerId: await getGtmID(),
                    id: await getGtmID(),
                    hubspotId: getCookieCustom('hubspotutk'),
                    account_id: ''
                } : {
                    customerId: await getGtmID(),
                    id: await getGtmID(),
                    hubspotId: getCookieCustom('hubspotutk'),
                    hash: step === 3 ? await getAccountID() : '',
                    account_id: step === 3 ? await getAccountID() : ''
                },
            cookies:
                await getCookies()
        });
    }
}

class PageViewEvent{
    construct()
    {
    }
    async push(type)
    {
        window.dataLayer = window.dataLayer || [];
        if(type === 'thank_you_page'){
            dataLayer.push({
                event: 'page_view',
                type: type,
                user:  //we want user data in a dedicated object for consistency and overall tidiness
                    {
                        id: await getGtmID(),
                        hash: await hashEmail(),
                        account_id: await getAccountID(),
                        tier:  '4'
                    },
                cookies:
                    await getCookies()
            });
        }else{
            dataLayer.push({
                event: 'page_view',
                type: type
            });
        }
    }
}

function setGtmSync() {
    $.ajax({
        url: '../monitoring/?do=setGtmSync',
        type: 'POST',
        dataType: ''
    }).done(function(data) {
        return data;
    });
}

class StartTrialEvent{
    construct()
    {
    }
    async push(step, options)
    {
        if(await getEligibility()){
            let userData = await getUserData();
            let cookies = await getCookies();
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                event: 'start_trial',
                step: step,
                options: options,
                user:  //we want user data in a dedicated object for consistency and overall tidiness
                    userData,
                cookies:
                    cookies
            });
            window.lintrk('track', { conversion_id: 17089986 });
            setGtmSync();
            await logMQL(userData, cookies);
        }
    }
}

class GTagEvent {
    construct() {

    }

    async push() {
        if (await getEligibility()) {
            gtag('event', 'conversion', {'send_to': 'AW-16764202434/2dtjCP-Fr-UZEMLb5bk-'});
        }
    }
}

class StartTrialTieringEvent{
    construct()
    {
    }
    async push(event, step, options)
    {
        if(await getEligibility()){
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                event: event,
                step: step,
                options: options,
                user:  //we want user data in a dedicated object for consistency and overall tidiness
                    await getUserData(),
                cookies:
                    await getCookies()
            });
            setGtmSync();
        }
    }
}

function getCookieCustom(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function getEligibility(){
    return $.ajax({
        url: '../monitoring/?do=getEligibility',
        type: 'POST',
        dataType: '',
    }).done(function(data) {
        return data;
    });
}

function hashEmail(email) {
    return $.ajax({
        url: '../monitoring/?do=hashEmail',
        type: 'POST',
        dataType: '',
        data: {
            accountEmail: email
        }
    }).done(function(data) {
        return data;
    });
}

function findGetParameter(parameterName)
{
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
            tmp = item.split("=");
            if (tmp[0] === parameterName) {
                result = decodeURIComponent(tmp[1]);
            }
        });
    return result;
}

class PurchaseEvent{
    construct()
    {
    }
    async push()
    {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            step: 1,
            event: 'begin_checkout',
            ltv: await getLtv(),
            currency: 'USD',
            transaction:
                await getPurchaseData(),
            user:  //we want user data in a dedicated object for consistency and overall tidiness
                await getUserData()
        });
    }
}

class ClientSideCheckOut{
    construct()
    {

    }
    async push()
    {
        dataLayer.push({
            event: eventName,
            ecommerce:
                getClientEcommerce(),
            user_data:  //we want user data in a dedicated object for consistency and overall tidiness
                await getUserData(),
            company_data:
                await getCompanyData()
        });
    }
}

const cyrb53 = (str, seed = 0) => {
    if(str === null){
        return '';
    }
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for(let i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1  = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
    h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2  = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
    h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);

    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};

function getClientEcommerce()
{
    return {
        event: "begin_checkout", //all 4 variants could be under 1 event name or separate names
        ecommerce:
            {
                value: Number($('.price').text()) - Number($('.price-vat-place').text()), //full revenue w/o accounting for discount or taxes
                tax: Number($('.price-vat-place').text()),
                coupon: $('input[name="codeInput"]').val(),
                discount_amount: $('.discount-percent').text(),
                currency: 'USD',
                items: [ //array of product objects
                    {
                        item_id: '1111222',   //at lease item_id or item_name is required, both ideally
                        item_name: mainProduct.name,
                        price: duration == 'Annually' ? mainProduct.annually : mainProduct.monthly,  // product price w/o accounting for any discounts
                        quantity: 5
                    },
                    {
                        item_id: '40',
                        item_name: 'additional_members',
                        price: duration == 'Annually' ? mainProduct.annually : mainProduct.monthly,
                        quantity: members - mainProduct.hasMembers,
                    },
                    {
                        item_id: '13',
                        item_name: 'dedicated_gateway',
                        price: gatewayPrice,
                        quantity: gateways - mainProduct.hasGateways,
                    },
                    {
                        item_id: '11',
                        item_name: 'cloud/branch_connector',
                        price: branchPrice,
                        quantity: branches - mainProduct.hasBranches,
                    },
                ]
            }
    }


}

function logMQL(userData, cookies)
{
    return $.ajax({
        url: '../monitoring/?do=logMQL',
        type: 'POST',
        dataType: '',
        data: {
            cookies: cookies,
            userData: userData
        }
    }).done(function (data) {
        return data;
    });
}

function getUserData()
{
    return $.ajax({
        url: '../monitoring/?do=getUserData',
        type: 'GET',
        dataType: ''
    }).done(function (data) {
        return data;
    });
}

function getLtv() {
    return $.ajax({
        url: '../monitoring/?do=getLtv',
        type: 'GET',
        dataType: ''
    }).done(function (data) {
        return data;
    });
}

function getCompanyData()
{
    return $.ajax({
        url: '../monitoring/?do=getCompanyData',
        type: 'GET',
        dataType: ''
    }).done(function (data) {
        return data;
    });
}

function getCookies()
{
    return $.ajax({
        url: '../monitoring/?do=getCookies',
        type: 'GET',
        dataType: ''
    }).done(function (data) {
        return data;
    });
}

function getGtmID()
{
    return $.ajax({
        url: '../monitoring/?do=getGtmID',
        type: 'GET',
        dataType: ''
    }).done(function (data) {
        return data;
    });
}

function getAccountID(accEmail)
{
    return $.ajax({
        url: '../monitoring/?do=getAccountID',
        type: 'GET',
        dataType: '',
        data: {
            accountEmail: accEmail
        }
    }).done(function(data) {
        return data;
    });
}

function getPurchaseData()
{
    return $.ajax({
        url: '../monitoring/?do=getPurchaseData',
        type: 'GET',
        dataType: ''
    }).done(function (data) {
        return data;
    });
}

window.FreeTrialEvent = FreeTrialEvent;
window.PageViewEvent = PageViewEvent;
window.StartTrialEvent = StartTrialEvent;
window.StartTrialTieringEvent = StartTrialTieringEvent;
window.PurchaseEvent = PurchaseEvent;
window.GTagEvent = GTagEvent;